import type { Locale } from "@memorang/constants/i18n";
import { t } from "i18next";
import {
	type TranslationsType,
	en,
	enGB,
	es,
	fr,
	hi,
	id,
	ja,
	ko,
	pt,
	registerTranslation,
	th,
	tr,
	zh,
	zhTW,
} from "react-native-paper-dates";

const LOCALE_TRANSLATIONS: Record<Locale, TranslationsType> = {
	"en-GB": enGB,
	"en-US": en,
	"es-MX": es,
	"fil-PH": en,
	"fr-FR": fr,
	"hi-IN": hi,
	"id-ID": id,
	"ja-JP": ja,
	"ko-KR": ko,
	"ms-MY": en,
	"pa-IN": en,
	"pt-BR": pt,
	"th-TH": th,
	"tr-TR": tr,
	"vi-VN": en,
	"zh-CN": zh,
	"zh-Hant-TW": zhTW,
};

const registeredLocales = new Set<string>();

const withValidationMessages = (
	translation: TranslationsType,
): TranslationsType => ({
	...translation,
	mustBeHigherThan: (date) => t("common.datePicker.minDateError", { date }),
	mustBeLowerThan: (date) => t("common.datePicker.maxDateError", { date }),
	mustBeBetween: (startDate, endDate) =>
		t("common.datePicker.dateRangeError", { startDate, endDate }),
});

export const getDatePickerLocale = (locale: string): string => {
	const translation = LOCALE_TRANSLATIONS[locale as Locale];
	const resolvedLocale = translation ? locale : "en-US";
	if (!registeredLocales.has(resolvedLocale)) {
		registerTranslation(
			resolvedLocale,
			withValidationMessages(translation ?? en),
		);
		registeredLocales.add(resolvedLocale);
	}
	return resolvedLocale;
};
